import Mutations from '../../odata/mutations';

export default { ...new Mutations('orgTarget'), ...new Mutations('orgTargets') };
